<template>
    <div>
        <div class="container">
            <div class="row">
                <div class=" btn-home  col-md-12 mt-3 mb-4 d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="text-center card-header text-white h4 bg-main">
                        <strong>DISEÑO</strong>
                    </div>
                    <div class="card-body w-100">
                        <div class="row">
                            <div class="col-md-12 py-2">
                                <div class="row mx-0">
                                    <!-- <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 mb-2">
                                        <div class="input-group input-group">
                                            <span class="input-group-text" id="basic-addon1"
                                            >Sede</span
                                            >
                                            <select
                                            class="form-control form-control-sm"
                                            v-model="filter.campus_id"
                                            @change="mtdGetData()"
                                            >
                                            <option :value="null" disabled>Seleccione</option>
                                            <option
                                                v-for="(item, index) in dataCampus"
                                                :key="index"
                                                :value="item.id"
                                            >
                                                {{ item.name }}
                                            </option>
                                            </select>
                                        </div>
                                    </div> -->
                                    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1">
                                        <div class="input-group input-group">
                                            <span class="input-group-text text-white bg-main"
                                            ><i class="fas fa-search"></i
                                            ></span>
                                            <input
                                            @keyup="calculateData(7)"
                                            v-model="search"
                                            type="text"
                                            class="form-control form-control"
                                            placeholder="Buscar"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-home px-1 py-xl-0 my-xl-0 my-2">
                                        <button
                                            type="button"
                                            class="btn btn-bm-noradius w-100"
                                            @click="mtdModalShow(0,null)"
                                        >
                                            <i class="fas fa-plus"></i> Nueva
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-2" id="content-timelinetable">
                                <table id="tb-cxc" class="table table-bordered border-main text-xs">
                                    <caption class="py-0 my-0"></caption>
                                    <thead class="bg-main">
                                        <tr class=" table-th text-white text-center">
                                            <th class="table-th-number">N°</th>
                                            <th>DISEÑO</th>
                                            <th>LOGO</th>
                                            <th>GRABADO</th>
                                            <!-- <th>SEDE</th> -->
                                            <th class="table-th-number">ESTADO</th>
                                            <th class="table-th-acciones">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody class="border-main">
                                        <tr class="table-body text-center" v-if="cpData.length === 0">
                                            <td colspan="6" class="text-center">No hay registros</td>
                                        </tr>
                                        <tr class="table-body text-center" v-for="(item, index) in cpData" :key="index">
                                            <td>
                                                {{index+1}}
                                            </td>
                                            <td class="">
                                                {{item.name}}
                                            </td>
                                            <td class="">
                                                <div >
                                                    <div v-if="item.logo">
                                                   
                                                        <!-- <img src="@/assets/user/firma/img/528b1359-329b-4c6a-8a2c-59c1299da941.png" :alt="'firma de'+item.name" style="width: 50px; height: auto;"> -->
                                                        <img :src="'https://clinicabm.v2.howertpi.com/assets/'+item.logo" :alt="' logo '+item.name" style="width: 50px; height: auto;">
                                                    </div>
                                                    <div v-else>-</div>
                                                </div>
                                            </td>
                                            <td class="">
                                            <div >
                                                    <div v-if="item.grabado">
                                                       
                                                        <!-- <img src="@/assets/user/firma/img/528b1359-329b-4c6a-8a2c-59c1299da941.png" :alt="'firma de'+item.name" style="width: 50px; height: auto;"> -->
                                                        <img :src="'https://clinicabm.v2.howertpi.com/assets/'+ item.grabado" :alt="'grabado '+item.name" style="width: 50px; height: auto;">
                                                    </div>
                                                    <div v-else>-</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="state_speciality" v-if="item.state == 1">
                                                    <div class="bg-success text-white">Activo</div>
                                                </div>
                                                <div id="state_speciality" v-else>
                                                    <div class="bg-secondary text-white">Inactivo</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="text-center d-flex justify-content-center">
                                                    <button
                                                        class="btn btn-sm a-success text-white" @click="mtdModalShow(1, item)">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button 
                                                        class="btn btn-sm a-danger text-white" @click="Datadetail(item.id ,2)">
                                                        <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                    </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 text-center">
                                <!-- paginado -->
                                <div v-if="cpData.length > 0" class="d-flex justify-content-center mb-2">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination mb-1">
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                                <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
    
                                            <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                                <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                                </a>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                                <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                                </a>
                                            </li>
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <cModalCategoryVue :dataCampus="dataCampus"  :input="modal.input" :num="modal.num" :payload="modal.payload" :title="modal.title" 
        :boo_modal="modal.modal_form" @closeModal="closeModal" @Datadetail="Datadetail" />
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import {
    mapActions
} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalCategoryVue from '../Modals/cModalDesign.vue'
export default {
    name: "c-mantenedores-pages-categoria",
    components: {
        SweetAlert,
        cModalCategoryVue
    },
    data() {
        return {
            swal: null,
            search:"",
            dataShow: [],
            dataCategory: [],
            dataCampus:[],
            estado: "activo",
            category: {
                name: "",
                id: "",
                state: "",
            },
            filter: {
                category:"",
                campus_id:null
            },
            posEdit: null,

            modal: {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            },
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
           
        };
    },
    watch: {
        selectPage() {
            this.calculateData(7);
        },
    },
    computed: {
        classTh() {
            return 'align-middle border border-5 bg-main border-white';
        },
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

    },
    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),
      
        //Traer Data
        mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/Desing",
                token: this.$store.getters.get__token,
                params:this.filter
            })
            .then((response) => {
                this.dataCategory = response.data;
                this.calculateData(7);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        calculateData(items) {
            if (!this.dataCategory || !this.dataCategory.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataCategory;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.dataCategory.filter((element) => {
                    let name = element.name.toString().toUpperCase();
                    return name.includes(query);
                });
                indexInitial = 1;
            }

            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );

            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },

        mtdModalShow: function (num, payload) {
            this.modal.title = (num == 0) ? 'Registrar Diseño' : 'Editar Diseño';
            this.modal.modal_form = true;
            this.modal.num = num;
            this.modal.payload = payload;
            //console.log(payload);
        },

        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            }
        },

        Datadetail: function (payload_detail, num_detail) {
            if (num_detail == 0) {
                payload_detail.action = 'c';
                this.addDatadetail(payload_detail, num_detail);
            } else if (num_detail == 1) {
                payload_detail.action = 'u';
                this.addDatadetail(payload_detail, num_detail);
            } else {
                let data = {
                    action : 'd',
                    id : payload_detail
                }
                this.filter.category=payload_detail;
        
                this.$refs.SweetAlert.showConfirmSimple2("","¿Estás seguro?","warning","Eliminar") 
                .then((result) => {
                    if (result.value) {
                        if(this.dataSubcategorie.length==0){
                            this.addDatadetail(data, num_detail);
                        } else {
                            let mensaje="";
                            this.dataSubcategorie.forEach(element => {
                                mensaje+=element.name +"/ ";
                            });
                            mensaje = mensaje.slice(0, -2);
                            
                            this.$refs.SweetAlert.showConfirmSimple2("Se eliminaran las SubCategorias:",mensaje,"warning","Continuar") 
                            .then((result) => {
                                if (result.value) {
                                    this.dataSubcategorie.forEach(element=>{
                                        this.mtdDeleteDataSubcategory(element);
                                    });
                                    this.addDatadetail(data, num_detail);
                                }
                            });
                        }
                    }
                });
            }
        },

        addDatadetail: function (payload_detail, num_detail) {
            let formData = new FormData();
            formData.append("id", payload_detail.id);
            formData.append("name", payload_detail.name);
            formData.append("logo", payload_detail.logo);
            formData.append("engraved", payload_detail.grabado);
            formData.append("campu_id", payload_detail.campu_id);
            formData.append("action", payload_detail.action);
            this.post({
                    url: this.$store.getters.get__url + "/Desing/crudDesing",
                    token: this.$store.getters.get__token,
                    params: formData,
                })
                .then(response => {
                    if (num_detail == 2) {
                        this.$refs.SweetAlert.showSuccess("El registro ha sido eliminado");
                        this.mtdGetData();
                    } else {
                        this.$refs.SweetAlert.showSuccess(num_detail == 0 ? "Registro Exitoso" : "Modificación Exitosa");
                        this.closeModal()
                        this.mtdGetData();
                        
                    }
                })
                .catch(error => {
                    this.$refs.SweetAlert.showError(error);
                })
        },

        checkEmptyPageAndUpdate() {
            this.mtdGetData();
            if (this.dataShow.length === 0 && this.selectPage > 1) {
                this.backPage();
                this.mtdGetData();
            }
        },

        //metodo eliminar subcategoria
        mtdDeleteDataSubcategory: function (objeto) {
            let data = {
                action : 'd',
                id : objeto
            }
            this.post({
                url: this.$store.getters.get__url + "/SubCategory/crudSubCategory",
                token: this.$store.getters.get__token,
                params: data,
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function(index){
            return (this.selectPage-1)*10 + (index + 1)
        },
        returnHome: function () {
            this.$emit("returnHome");
        },
    }
}
</script>